import { closeModal } from '@/function/function.js';
import $ from 'jquery'

export default {
    name: 'caisse-cloture',
    components: {},
    props: ["solde_caisse", "user_id", "compte_id"],
    data() {
        return {
            loading: false,
            save_loading: false,
            is_confirm: false,
            check_sans_versement: false
        }
    },
    
    computed: {
        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },
    },

    mounted() {

    },

    methods: {
        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Faire un versement suite à laquelle l'on fera une clôture de la caise
         * @param {*} selector 
         */
        faireVersement(selector) {
            this.closeModal(selector);
            this.$store.commit("SET_IS_CLOSING_CASH", true);
            this.$router.push({ path: '/clinicaa/comptabilite/caisse/versement' });
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },
        sans_versement_checking() {
            this.check_sans_versement = false
            $('#cfrm-cloture').prop('checked', false);
            $('.err-msg').fadeOut(500)
            this.is_confirm = false
        },

        /**
         * Cloturer la caisse sans faire de versement
         */
        cloturerCaisse() {
            this.save_loading = true;
            this.check_sans_versement = true;
            if (!this.is_confirm) {
                this.is_confirm = true
                this.save_loading = false;
            } else {
                let confirm = document.getElementById('cfrm-cloture');
                let err = 0
                if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                    $('.err-msg').fadeIn(500)
                    err++;
                    this.save_loading = false;
                }

                if (err == 0) {
                    const data_cloture = {
                        user_id: this.user_id,
                        compte_id: this.compte_id,
                        solde_cloture: this.solde_caisse,
                        date_cloture: '0000'
                    }

                    this.$store.dispatch('closeCaisse', data_cloture).then((response) => {
                        if (response.success) {
                            this.$emit("updateStatut")
                            this.$refs.c_cloture.click()
                        } else {
                            if (response.code === 500) {
                                this.warningToast("Une erreur s'est produite !")
                            } 
                        }
                        this.loading = false;
                    }).catch(() => {
                        this.warningToast("Une erreur s'est produite !")
                        this.loading = false;
                    })
                }
            }
        }
    }
}